import { FullScreenLoadingSpinner } from '@/components/full-screen-loading-spinner';
import { apiQueryKeys } from '@/services/apis/apiQueryKeys';
import { getMobilePlanCard } from '@/services/apis/getPlanCard';
import { SCROLLABLE_IDS } from '@/constants/app.constants';
import { useQuery } from '@tanstack/react-query';
import PlanCardMobile from './plan-card-mobile';
import React from 'react';

const CMSPlanCardMobile = () => {
  const { data, isPending, isError } = useQuery({
    queryFn: getMobilePlanCard,
    queryKey: [...apiQueryKeys.getPlanCards, 'MOBILE'],
    staleTime: Infinity,
  });

  React.useEffect(() => {
    if (isPending && data) {
      return;
    }

    const hash = window.location.hash;
    if (!hash) {
      return;
    }

    const replacedHash = hash.replace('#', '');
    if (replacedHash !== SCROLLABLE_IDS.MOBILE_PLAN) {
      return;
    }

    const mobilePlan = document.getElementById(SCROLLABLE_IDS.MOBILE_PLAN);
    if (!mobilePlan) {
      return;
    }
    mobilePlan.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [isPending, data]);

  if (isPending) {
    return <FullScreenLoadingSpinner />;
  }

  if (isError) {
    return null;
  }

  return (
    <div
      id={SCROLLABLE_IDS.MOBILE_PLAN}
      className="flex h-full flex-col gap-[16px] md:flex-row md:gap-[32px] justify-center"
    >
      {data.map((mobilePlanData, index) => {
        return <PlanCardMobile key={index} mobilePlanData={mobilePlanData} />;
      })}
    </div>
  );
};

export { CMSPlanCardMobile };
